import { Injectable } from '@angular/core';
import { ListWalletAlertsGroupedRequestParams } from 'src/generated-sources/openapi/alert-service/alert';
import { validateBrazilianDocument } from 'src/app/helpers/documents-utils';
import { FlattenedIndicator, RelationshipLevel } from '../models/wallet-alert-report.models';
import {
  ALL_INDICATORS_OPTION,
  LOADING_INDICATORS_OPTION,
  NO_INDICATORS_OPTION,
  DEFAULT_PER_PAGE,
} from '../models/wallet-alert-report.constants';

@Injectable({ providedIn: 'root' })
export class AlertRequestBuilderService {
  /**
   * Builds request parameters for listing wallet alerts.
   *
   * Special handling:
   * - ALL_INDICATORS_OPTION: No indicatorId filter (fetches all)
   * - document: Validates as Brazilian CPF/CNPJ before adding to params
   */
  buildListWalletAlertsParams(
    walletId: string,
    indicator: FlattenedIndicator,
    document: string,
    page: number,
  ): ListWalletAlertsGroupedRequestParams {
    const params: ListWalletAlertsGroupedRequestParams = {
      walletId,
      page,
      perPage: DEFAULT_PER_PAGE,
    };

    if (this.isSpecificIndicator(indicator) && indicator.id) {
      params.indicatorId = indicator.indicatorIds;
      params.relationshipLevel = indicator.relationshipLevel ?? RelationshipLevel.ROOT;
    }

    const sanitizedDocument = this.sanitizeBrazilianDocument(document);
    if (sanitizedDocument) {
      params.document = sanitizedDocument;
    }

    return params;
  }

  private isSpecificIndicator(indicator: FlattenedIndicator): boolean {
    return (
      indicator.name !== ALL_INDICATORS_OPTION.name &&
      indicator.name !== NO_INDICATORS_OPTION.name &&
      indicator.name !== LOADING_INDICATORS_OPTION.name
    );
  }

  private sanitizeBrazilianDocument(document: string): string | null {
    if (!document) {
      return null;
    }

    const validation = validateBrazilianDocument(document);
    return validation.isValid ? document.toUpperCase().replace(/[^A-Z0-9]/g, '') : null;
  }
}
